(function ($) {

	class MyAccountPersonalData {

		constructor() {
			$(document).gp_ready(this.init_form)
		}

		init_form = () => {

			// Init elements
			let $billing_form = $('form[data-form-id="customer-billing-address"]')
			let $shipping_form = $('form[data-form-id="customer-shipping-address"]')

			// Init toggle events
			this.init_toggle_content($billing_form, 'add_company_info', '.billing-company')
			this.init_toggle_content($shipping_form, 'add_shipping_info', '.shipping-address')

		}

		init_toggle_content($form, checkbox_name, content_selector) {

			let $checkbox = $form.find('input[name="' + checkbox_name + '"]')
			let $content = $form.find(content_selector)

			// Show/hide on init
			if ($checkbox.is(':checked')) {
				$content.show()
			} else {
				$content.hide()
			}

			// Bind toggle
			$checkbox.off('change.toggle-' + checkbox_name)
			$checkbox.on('change.toggle-' + checkbox_name, () => {
				if ($checkbox.is(':checked')) {
					$content.slideDown(250)
				} else {
					$content.slideUp(250)
				}
			})
		}

	}

	new MyAccountPersonalData();

})(jQuery)